import { getImagePath } from '@/shared/lib/utils/asset.ts'

export interface NotificationMetadata {
  text: string
  color: string
  imageUrl: string
}

export const NOTIFICATION: NotificationMetadata | undefined = {
  text: new Date() >= new Date('2025-05-20 18:00:00+09:00') ? 'AVS season 1 has ended. season 2’s coming soon!' : 'rstKAIA upgrade complete',
  color: '#4314FF',
  imageUrl: getImagePath('purple.png', 'notification'),
}
